export { default } from './WindForecastContainer';
